import { render, staticRenderFns } from "./RecommendedItem.vue?vue&type=template&id=1f5397d0&scoped=true"
import script from "./RecommendedItem.vue?vue&type=script&lang=js"
export * from "./RecommendedItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendedItem.vue?vue&type=style&index=0&id=1f5397d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5397d0",
  null
  
)

export default component.exports